export default "__VITE_ASSET__DYNrb4s7__"